/**
 * Checks if the page uses header 2
 * @returns {boolean}
 */
export const isHeader2 = Boolean(document.querySelector('body.header-2'));

/**
 * Checks if the page is an area search mask page
 * @returns {boolean}
 */
export const isASM = Boolean(document.body.classList.contains('g_area-search'));

/**
 * Checks if the page has no hero section
 * @returns {boolean}
 */
export const hasNoHero = () => $('.m-hero--slide').length == 0 || $('body').hasClass('g_gms-free-content');


/**
 * Key codes
 */
export const keys = {
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  enter: 13,
  space: 32,
  tab: 9,
  escape: 27,
};

